import type {
  PortfolioCorrectionCommandData,
  SubPortfolioCorrection,
} from '@festina/unitlink-general-types/unitlink'
import { typeUtils } from '@festina-life/core'
import { FormikFieldArray, FormikForm } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'
import type { CommandDataFormProps } from '../../commandActions/CommandDataFormAndSimulation'
import { SubPortfolioCorrectionFields } from './SubPortfolioCorrectionFields'

const validateKey = typeUtils.createValidator<PortfolioCorrectionCommandData>()

export const PortfolioCorrectionForm = (
  props: CommandDataFormProps<PortfolioCorrectionCommandData>,
) => {
  const translate = useTranslate()

  const { ownerId } = useHook('routing.general.useEntityParams')()

  const initialValues: PortfolioCorrectionCommandData = {
    _type: 'PortfolioCorrectionCommandData',
    portfolioOwnerId: ownerId,
  }

  return (
    <FormikForm initialValues={initialValues} {...props}>
      <FormikFieldArray
        name={validateKey('subPortfolioCorrections')}
        label={translate('portfolioCorrection.subPortfolioCorrections')}
        elementLabel={translate('portfolioCorrection.subPortfolioCorrection')}
        elementInitializer={() =>
          ({
            _type: 'SubPortfolioCorrection',
            correctionId: crypto.randomUUID(), // contact: kb
            subPortfolioRef: { _type: 'SubPortfolioLifeRef' },
          }) satisfies SubPortfolioCorrection
        }
        ChildElement={SubPortfolioCorrectionFields}
      />
    </FormikForm>
  )
}
